// ------------------------------------
// Animar no Scroll
// ------------------------------------

// Executa o plugin AOS quando a página terminar de carregar
/* $(window).on('load', function () {
  AOS.init({
    duration: 800,
  });
}); */
/* $(document).ready(function () {
  if (!modoEditor) {
    AOS.init({
      duration: 600,
    });
  }
}); */

// Variáveis
const scrollAnimationOffset = 100;
const scrollAnimationDebounce = 50;

// Executa uma acão quando o elemento estiver visível na tela
function doWhenVisible($el, callback) {
  const $window = $(window);
  let executed = false;
  $window.on(
    'scroll',
    debounce(function () {
      checkVisibility();
    }, scrollAnimationDebounce),
  );
  // Verifica se o elemento está visível na tela
  function checkVisibility() {
    if (isElVisible($el)) {
      if (!executed) {
        callback();
        executed = true;
      }
    } else {
      executed = false;
    }
  }
  checkVisibility();
}

// Verifica se o elemento está visível na tela
function isElVisible($el) {
  /* const $window = $(window);
  const scrollTop = $window.scrollTop();
  const windowHeight = $window.height();
  const eleTop = $el.offset().top;
  return scrollTop + windowHeight > eleTop + scrollAnimationOffset; */
  const topOfElement = $el.offset().top;
  const bottomOfElement = $el.offset().top + $el.outerHeight();
  const bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
  const topOfScreen = $(window).scrollTop();
  return bottomOfScreen > topOfElement && topOfScreen < bottomOfElement;
}
